import { z } from 'zod';
import { api } from './client';
import { cleanParams, moneySchema } from './schemas';

export const payoutKeys = {
  all: ['payouts'] as const,
  list: (range: object) => ['payouts', 'list', range] as const,
};

export const payoutSchema = z.looseObject({
  id: z.number(),
  amount: moneySchema,
  reason: z.string(),
  paid_date: z.string().nullish(),
  paid_at: z.string().nullish(),
  user_id: z.number().nullish(),
  user_name: z.string().nullish(),
  shift_session_id: z.number().nullish(),
});
export type Payout = z.infer<typeof payoutSchema>;

const payoutListSchema = z.looseObject({
  data: z.array(payoutSchema),
  meta: z.looseObject({
    from: z.string().nullish(),
    to: z.string().nullish(),
    total: moneySchema,
    count: z.number(),
  }),
});
export type PayoutList = z.infer<typeof payoutListSchema>;

/** Today by default. `from`/`to` are honoured for admins only. */
export async function listPayouts(range: { from?: string; to?: string } = {}): Promise<PayoutList> {
  const { data } = await api.get('/payouts', { params: cleanParams(range) });
  return payoutListSchema.parse(data);
}

export async function createPayout(input: { amount: number; reason: string }): Promise<Payout> {
  const { data } = await api.post('/payouts', input);
  return z.looseObject({ data: payoutSchema }).parse(data).data;
}

export async function deletePayout(id: number): Promise<void> {
  await api.delete(`/payouts/${id}`);
}
